/**
 * Cypher Challenge — marketing + discovery config.
 * Official challenge beats use beats.beat_type = 'cypher' (see docs/BEAT_TYPE_SETUP.md).
 */
export const CYPHER_TAG = 'cypher'; // legacy tag; prefer beat_type column

/** Optional hard-pinned beat UUIDs (shown first when present and beat_type = cypher). */
export const CYPHER_FEATURED_BEAT_IDS: string[] = [
  // e.g. 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
];

export const CYPHER_COPY = {
  eyebrow: 'Live session',
  title: 'Cypher Challenge',
  subtitle:
    'One beat. Many rappers. Drop your bars in the booth and stack the cypher — same studio recorder, bigger energy.',
  homePromoTitle: 'Cypher Challenge is live',
  homePromoBody:
    'Jump into the booth, spit over featured beats, and see who else is in the session.',
  homePromoCta: 'Enter the cypher',
} as const;

export const CYPHER_STEPS = [
  {
    step: '01',
    title: 'Pick the beat',
    body: 'Choose a challenge track — preview it, feel the pocket, then claim your slot.',
  },
  {
    step: '02',
    title: 'Drop your bars',
    body: 'Record in-browser with the studio mixer. Headphones optional — your take uploads as an MP3.',
  },
  {
    step: '03',
    title: 'Stack the cypher',
    body: 'Your verse joins the session. Listen, vote, and come back for the next round.',
  },
] as const;

export const CYPHER_BEATS_LIMIT = 8;
export const CYPHER_VERSES_LIMIT = 12;
